import axios from "axios";
// export const token = "";
import {
  IP
} from "@/services/config.js";
// export const token =
//   "Bearer " + JSON.parse(localStorage.getItem("userInfo"))?.access_token;
// const baseURL = "/backend-api";
// const service = axios.create({
//   baseURL,
//   timeout: 30000
// });


const baseURL = IP;
export const request = axios.create({ baseURL, timeout: 100000 });
/**
 * request
 * 请求拦截器
 */
request.interceptors.request.use(
  (config) => {
    // console.log("config", config);
    // 配置请求头
    // config.headers["Authorization"] = JSON.parse(
    //   localStorage.getItem("supUser")
    // )?.webToken;
    // config.headers["Authorization"] = token;
    // let data = config.data;
    // Object.entries(data).forEach(
    //   ([k, v]) =>
    //     (data[k] = RSA.encrypt(v, {
    //       key: DEFAULT_PUB_KEY,
    //     }))
    // );
    // console.log("params", data);
    return config;
  },
  (error) => {
    console.error(error);
  }
);


/**
 * 响应拦截器
 */
request.interceptors.response.use(
  (res) => {
    if (res.status === 200) {
      return res.data;
    } else {
      console.log(res);
    }
  },
  (error) => {
    //处理是否为token过去 跳转到登录页
    console.log(error);
  }
);
